var _path, _path2, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 112.24C87.3757 112.24 112 87.5617 112 57.1198C112 26.678 87.3757 2 57 2C26.6243 2 2 26.678 2 57.1198C2 87.5617 26.6243 112.24 57 112.24Z",
    fill: "white",
    stroke: "#05C3DE",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0455 64.8773V64.8773C77.9353 64.8773 79.4649 66.4064 79.4649 68.2955C79.4649 70.1846 77.9353 71.7137 76.0455 71.7137H73.766C75.6557 71.7137 77.1853 73.2428 77.1853 75.132C77.1853 77.0211 75.6557 77.4108 73.766 77.4108H58.949C52.4523 77.4108 50.9706 76.2714 42.9922 75.132V55.762C48.5771 55.762 57.8092 45.5073 57.8092 36.3921C57.8092 32.7893 62.7991 31.447 64.6478 38.0305C65.7876 42.0891 62.3683 50.065 62.3683 50.065H80.6046C82.4944 50.065 84.0239 51.5941 84.0239 53.4832C84.0239 55.3723 82.4944 58.0408 80.6046 58.0408H78.3251C80.2148 58.0408 81.7444 59.5699 81.7444 61.4591C81.7444 63.3482 80.2148 64.8773 78.3251 64.8773H76.0455",
    stroke: "#05C3DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 32,
    width: 56,
    height: 49
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7695 80.8632H85.7695V32.5273H30.7695V80.8632Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6406 80.0004H42.9898V52.3799H31.6406V80.0004Z",
    stroke: "#05C3DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0634 73.958C38.3406 73.958 37.7539 74.538 37.7539 75.2527C37.7539 75.9674 38.3406 76.5474 39.0634 76.5474C39.7863 76.5474 40.373 75.9674 40.373 75.2527C40.373 74.538 39.7863 73.958 39.0634 73.958Z",
    fill: "#05C3DE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.2714bc86fdd04823fa0a42450b11c0ed.svg";
export { ForwardRef as ReactComponent };